import type { ColumnDef } from '@tanstack/react-table';

import { type GetDeliveryZonesQuery, DeliveryZoneState } from 'data/__generated__';
import { textColumn, numberColumn } from 'components/DataTable';

export type DeliveryZoneRow = GetDeliveryZonesQuery['deliveryZones'][number];

export const deliveryZonesColumns: ColumnDef<DeliveryZoneRow, unknown>[] = [
    textColumn<DeliveryZoneRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
    textColumn<DeliveryZoneRow, Record<string, unknown>>({
        id: 'color',
        accessorFn: (row) => row.color,
        header: 'Couleur',
        defaultVisible: true,
        cell: ({ row }) => (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <span
                    style={{
                        width: 16,
                        height: 16,
                        borderRadius: 4,
                        backgroundColor: row.original.color,
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                    }}
                />
                {row.original.color}
            </span>
        ),
    }),
    textColumn<DeliveryZoneRow, Record<string, unknown>>({
        id: 'referent',
        accessorFn: (row) => row.referentDeliverer?.profile.fullname ?? '',
        header: 'Appro référent',
        defaultVisible: true,
        cell: ({ row }) => row.original.referentDeliverer?.profile.fullname ?? '—',
    }),
    numberColumn<DeliveryZoneRow, Record<string, unknown>>({
        accessorKey: 'sitesCount',
        header: 'Sites',
        defaultVisible: true,
    }),
    textColumn<DeliveryZoneRow, Record<string, unknown>>({
        id: 'state',
        accessorFn: (row) => row.state,
        header: 'Statut',
        defaultVisible: true,
        cell: ({ row }) => (row.original.state === DeliveryZoneState.Archived ? 'Archivé' : 'Regular'),
    }),
];
